import { Link } from "react-router-dom";
import IconHome from "../../../styles/icons/IconHome";
import { ActiveDropdownGeneratorDrawer } from "../../../utils/helpers/helperMethods/NavigationControllersHelper";

interface DropdownItem {
  name: string;
  url?: string;
  icon?: string;
  navigation: string;
}

interface Props {
  menuItemName: string;
  dropdownMenuList: DropdownItem[];
  isOpen: boolean;
  handleSetSelectedDropdownMenu: (name: string) => void;
  selectedDropdownMenu: string;
}

const MobileDrawerDropdwonController = ({
  menuItemName,
  dropdownMenuList,
  isOpen,
  handleSetSelectedDropdownMenu,
  selectedDropdownMenu,
}: Props) => {
  if (!isOpen) return null;

  return (
    <div className="bottom-section">
      <div className="dropdown-menu-box">
        {dropdownMenuList.map((item, index) => (
          <Link
            className="list-styles-drawer"
            to={item.navigation}
            key={`${menuItemName}-${item.name}-${
              item.navigation || item.url || "no-nav"
            }-${index}`}
            onClick={() => handleSetSelectedDropdownMenu(item.name)}
          >
            <div className="menu-item-drawer">
              {item.icon && (
                <div className="logo">
                  <IconHome
                    breadcrumb={item.icon}
                    activeColor={ActiveDropdownGeneratorDrawer(
                      selectedDropdownMenu,
                      item.name
                    )}
                  />
                </div>
              )}

              <div
                className={`menu-item-name ${
                  selectedDropdownMenu === item.name ? "active-menu" : ""
                }`}
              >
                {item.name}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MobileDrawerDropdwonController;
